import {emotionStyled, tokens} from '@packages/utilities/styled';
import {HStack} from '../../Stack';

export const ModalHeaderView = emotionStyled('div')(
  {
    padding: '$2',
    display: 'flex',
    flexDirection: 'row',
  },
  {
    componentName: 'ModalHeader',
    variants: {
      hasBorder: {
        true: {
          borderBottom: '$border1',
        },
      },
    },
  }
);

export const ModalHeaderContentView = emotionStyled(HStack)(
  {
    padding: tokens.ui.modal.header.padding,
  },
  {
    variants: {
      hasCloseButton: {
        true: {
          paddingRight: '$10',
        },
      },
    },
  }
);
